module.exports = __webpack_public_path__ + "static/one-29d2d414b0cc2a008a2a55bc5f9c938c.jpeg";